import {
  EntityState,
  isEntityStateArchived,
} from 'components/common/dataGrid/columnsFactory/types';
import { InspectionTemplateModel } from 'shared/domain/template/inspectionTemplateModel';

export function filterTemplatesByEntityState(
  templates: InspectionTemplateModel[],
  state: EntityState
): InspectionTemplateModel[] {
  if (isEntityStateArchived(state)) {
    return templates.filter((template) => Boolean(template.deleted));
  }

  return templates.filter((template) => !template.deleted);
}

export function sortTemplatesByModifiedAtDesc(
  templates: InspectionTemplateModel[]
): InspectionTemplateModel[] {
  return [...templates].sort(
    (a, b) =>
      new Date(b.modifiedAt).getTime() - new Date(a.modifiedAt).getTime()
  );
}
